import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputDateComponent } from './form-input-date.component';
import { SharedModule } from '../../../modules/shared/shared.module';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    FormInputDateComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormInputErrorModule,
    DatePickerModule,
    FormsModule,
  ],
  exports: [
    FormInputDateComponent
  ]
})
export class FormInputDateModule { }
